import { createSelector } from 'reselect'
import {
    getGroupsCount,
    getMediaCount,
} from 'redux/navigation/selectors'

export const isThumbnailsNavigationOpened = state => state.thumbnails.isOpened === true

export const hasToAutoDisplayThumbnails = createSelector(
    isThumbnailsNavigationOpened,
    getMediaCount,
    getGroupsCount,
    (isThumbnailsNavigationOpened, mediaCount, groupsCount) => ! isThumbnailsNavigationOpened && (mediaCount > 1 || groupsCount > 1)
)
